<template>
    <div @click="close()" style="position: relative; cursor: pointer; z-index:9999;">
        <div :class="{activeBar: active}" class="snackBar" :style="{background: popInfo.background , color: popInfo.color}" style="position:fixed; left: 50%; transform: translateX(-50%); display:flex; justify-content: center; align-items: center; width: 398px; height: 37px; border-radius: 5px;">
            <img v-if="popInfo.icon" :src="getPic()" alt="" style="width: 21px; height: 21px; margin-right: 4px">
            <div v-if="popInfo.text" style="font-size: 15px; font-weight: 400; margin-top: 4px">{{popInfo.text}}</div>
            <p v-if="popInfo.btn" @click="goPath()" class="snackbar_btn" :style="{color: popInfo.color}" style="position: absolute; right: 15px; top: 8px; cursor: pointer; font-size: 14px">{{popInfo.btn}}</p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            popInfo: null,
            active: false,
            open: null,
            hide: null,
            closePop: null,
        }
    },
    computed: {
        snackBar() {
            return this.$store.state.snackBar
        }
    },
    watch: {
        snackBar: {
            deep: true,
            handler() {
                clearTimeout(this.open)
                clearTimeout(this.hide)
                clearTimeout(this.closePop)
                if(this.active) {
                    this.active = false
                    this.open = setTimeout(() => {
                        this.popInfo = JSON.parse(JSON.stringify(this.snackBar))
                        this.active = true
                    }, 500);
                    this.hidePop()
                } else {
                    this.popInfo = JSON.parse(JSON.stringify(this.snackBar))
                    this.active = true
                    console.log(this.active)
                    this.hidePop()
                }
            }
        }
    },
    methods: {
        goPath() {
            this.$router.push(this.popInfo.path)
        },
        hidePop() {
            this.hide = setTimeout(() => {
                this.active = false
            }, 5000)
            this.closePop = setTimeout(() => {
                this.$emit('close')
            }, 5500)
        },
        close() {
            this.active = false
            setTimeout(() => {
            }, 500);
            clearTimeout()
        },
        getPic() {
            return require('@/assets/images/icon/' + this.popInfo.icon)
        }
    },
    created() {
        this.popInfo = JSON.parse(JSON.stringify(this.snackBar))
        clearTimeout(this.open)
        clearTimeout(this.hide)
        clearTimeout(this.closePop)
        this.open = setTimeout(() => {
            this.active = true
        }, 100);
        this.hidePop()
    }
}
</script>
<style>
    .snackBar {
        bottom: -37px;
        transition: all 0.5s ease;
    }
    .activeBar {
        bottom: 24px
    }
    .snackbar_btn:hover {
        text-decoration: underline;
    }
</style>
